import { apiRequest } from "./axiosConfig";

// Create a organise list
export const createOrganiseListApi = async (list) => {
  return apiRequest("post", "/api/organiseLists/create", list);
};

// Fetch organise list for a user
export const fetchOrganiseList = async () => {
  return apiRequest("get", `/api/organiseLists`);
};

// Share organise list with user
export const shareOrganiseListApi = async (
  organiseId,
  email,
  inviterFirstName,
  inviterLastName
) => {
  return apiRequest("post", `/api/organiseLists/${organiseId}/share`, {
    email,
    inviterFirstName,
    inviterLastName,
  });
};

// Remove user from shared list
export const removeUserFromOrganiseList = async (organiseId, id) => {
  return apiRequest("delete", `/api/organiseLists/${organiseId}/share/${id}`);
};

// Remove organise list
export const removeOrganiseListApi = async (organiseId) => {
  return apiRequest("delete", `/api/organiseLists/${organiseId}`);
};

// Fetch organise edit logs
export const fetchOrganiseLogsApi = async (organiseId, nextUrl) => {
  if (!organiseId) return;
  const url = nextUrl
    ? nextUrl
    : `/api/organiseLists/logs/${organiseId}?limit=20`;
  return apiRequest("get", url);
};

// Fetch recently modified origanise list for a user
export const fetchRecentlyModifedOrganiseList = async () => {
  return apiRequest("get", `/api/organiseLists/recentlyModified`);
};
